import React, { useEffect } from 'react'
import './Home.css'
import PageTitle from '../components/UI/PageTitle'
import { useAuth } from '../api/Authcontext'
import { IoNewspaperOutline, IoPersonCircleOutline } from 'react-icons/io5'
import { FaRegCreditCard, FaBuildingColumns } from 'react-icons/fa6'
import { FaHandHoldingUsd } from 'react-icons/fa'
import Action from './../components/dashboard/Action'
import MobileAction from '../components/dashboard/MobileAction'
import Balance from '../components/dashboard/Balance'
import { GrMoney } from 'react-icons/gr'

const Home = () => {
  const { userData, refreshUserProfile } = useAuth();

  useEffect(() => {
    refreshUserProfile();
  }, []);
  
  // Get real user data from AuthContext
  const user = {
    name: userData?.name || 'User',
    email: userData?.email || 'user@example.com',
    role: userData?.role || 'user',
    currentLegacyCredits: userData?.currentLegacyCredits
  }

  // Dynamic greeting based on current time
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return 'Good morning';
    } else if (hour >= 12 && hour < 18) {
      return 'Good afternoon';
    } else {
      return 'Good evening';
    }
  }

  const userActions = [
    {
      icon: <FaRegCreditCard size={32} />,
      topName: 'My Legacy',
      bottomName: 'Credits',
      link: '/user-legacy-credits'
    },
    {
      icon: <FaHandHoldingUsd size={32} />,
      topName: 'My',
      bottomName: 'Loans',
      link: '/user-loans'
    },
    {
      icon: <IoNewspaperOutline size={32} />,
      topName: 'View',
      bottomName: 'Notices',
      link: '/notices'
    },
    {
      icon: <FaBuildingColumns size={32} />,
      topName: 'RWA',
      bottomName: 'Departments',
      link: '/departments'
    }
  ]


 const adminActions = [
    {
      icon: <FaRegCreditCard size={32} />,
      topName: 'Add Legacy',
      bottomName: 'Credit',
      link: '/add-legacy-credits'
    },
    {
      icon: <FaHandHoldingUsd size={32} />,
      topName: 'Create',
      bottomName: 'Loan',
      link: '/create-loan'
    },
    {
      icon: <IoNewspaperOutline size={32} />,
      topName: 'Create',
      bottomName: 'Notice',
      link: '/create-notice'
    },  
    {
      icon: <IoPersonCircleOutline size={32} />,
      topName: 'Create',
      bottomName: 'User',
      link: '/create-user'
    },
    {
      icon: <GrMoney size={32} />,
      topName: 'Create',
      bottomName: 'Investment',
      link: '/create-investment'
    },
    {
      icon: <FaBuildingColumns size={32} />,
      topName: 'Create',
      bottomName: 'Department',
      link: '/create-department'
    }
  ]


  // Determine which actions to show based on user role
  const currentActions = user.role === 'admin' ? adminActions : userActions;
  
  return (
    <div className='home'>
      <PageTitle title='Home Page' />
      <div className='greetings'>
        {getGreeting()}, {' '}<span>{user.name}</span>
      </div>

      {user.role === 'member' && <Balance balance={user.currentLegacyCredits}/>}

      <div className='actions'>
        {currentActions.map((action, index) => (
          <Action key={index} {...action} />
        ))}
      </div>

      <div className='mobile-actions'>
        {currentActions.map((action, index) => (
          <MobileAction key={index} {...action} />
        ))}
      </div>

    </div>
  )
}

export default Home